import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { AsyncPipe, CommonModule, NgFor } from '@angular/common';
import { AddCategoryComponent } from './add-category.component';
import { MAIN_ADDCATEGORY } from './add-category.routes';
import { MatTableModule } from '@angular/material/table';
import { PaginatorModule } from 'src/app/components/paginator/paginator.module';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { MatChipsModule } from '@angular/material/chips';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatDialog, MatDialogModule } from '@angular/material/dialog';
import { ModalSuccessfulComponent } from './modal-successful/modal-successful.component';

@NgModule({
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  declarations: [AddCategoryComponent, ModalSuccessfulComponent],
  providers: [MatDialog],
  imports: [
    CommonModule,
    MAIN_ADDCATEGORY,
    MatTableModule,
    MatChipsModule,
    PaginatorModule,
    MatIconModule,
    MatInputModule,
    MatButtonModule,
    MatFormFieldModule,
    MatSelectModule,
    MatChipsModule,
    NgFor,
    FormsModule,
    ReactiveFormsModule,
    MatAutocompleteModule,
    AsyncPipe,
    MatDialogModule,
  ],
  exports: [AddCategoryComponent],
})
export class AddCategoryModule {
  selected = 'option2';
}
